import { useNavigate, useParams } from '@tanstack/react-router';
import { MeetingDetail } from '@/features/meeting/MeetingDetail';

/**
 * A meeting read on its own route, rather than inside the My Towns list.
 *
 * This is the destination an alert email, a WhatsApp message, or a shared link lands on — so
 * it has to stand alone. Closing goes back in history if there is somewhere to go back to,
 * and falls through to My Towns otherwise, because a link opened in a fresh tab has no
 * history to return to.
 */
export function MeetingRoute() {
  const { meetingId } = useParams({ from: '/meeting/$meetingId' });
  const navigate = useNavigate();

  return (
    <MeetingDetail
      meetingId={meetingId}
      closeLabel="My Feed"
      onClose={() => {
        if (window.history.length > 1) window.history.back();
        else void navigate({ to: '/feed' });
      }}
    />
  );
}
